import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import SeatSelection from "./pages/SeatPage";
import MoviePage from "./pages/MoviePage";
import FavoritePage from "./pages/FavoritePage";
import BookingConfirmation from "./pages/BookingConfirmation";
import ProfilePage from "./pages/ProfilePage";
import BookingPage from "./pages/BookingPage";
import SupportPage from "./pages/SupportPage";
import SeedShowtimes from "./pages/SeedShowtimes";
import { AuthProvider } from "../src/components/AuthContext";
import Layout from "./components/Layout";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/movie/:id" element={<MoviePage />} />
            <Route path="/seats/:showId" element={<SeatSelection />} />
            <Route path="/book-later" element={<FavoritePage />} />
            <Route path="/booking-confirmation" element={<BookingConfirmation />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/reservations/:showId" element={<SeatSelection />} />
            <Route path="/bookings" element={<BookingPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/admin/seed-showtimes" element={<SeedShowtimes />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);
